import {
  dataAttribute,
  DataAttributes,
  Stack,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize
} from "@bps/fluent-ui";
import {
  OutboundCommDto,
  OutboundCommStatuses
} from "@libs/gateways/comms/CommsGateway.dtos.ts";

import {
  outboundCommStatusesColours,
  outboundCommStatusesText
} from "../components/CommunicationHistory.types.ts";

interface CommunicationStatusCellProps {
  item?: OutboundCommDto;
}

export const CommunicationStatusCell: React.FC<
  CommunicationStatusCellProps
> = ({ item }) => {
  let badgeColour: TextBadgeColor;
  let statusText: string;

  if (item) {
    badgeColour =
      outboundCommStatusesColours[item.statusCode as OutboundCommStatuses];
    statusText =
      outboundCommStatusesText[item.statusCode as OutboundCommStatuses];
  } else {
    badgeColour = TextBadgeColor.lightGrey;
    statusText = "";
  }
  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      styles={{ root: { width: "100%" } }}
    >
      {item && (
        <TextBadge
          badgeColor={badgeColour}
          badgeSize={TextBadgeSize.medium}
          {...dataAttribute(
            DataAttributes.Element,
            "communicationHistory-badge"
          )}
        >
          {statusText}
        </TextBadge>
      )}
    </Stack>
  );
};
